// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blockHead__I87ge {
  min-height: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.blockTitle__NTK2b {
  font-size: 11px;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  display: flex;
  align-items: center;
  column-gap: 5px;
}

.blockContainer__jA6u6 {
  padding: 25px;
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--table-box-shadow);
}

.information__IN9gK {
  font-size: 14px;
  line-height: 17px;
  color: var(--tables-primary-row-text-main);
  margin-bottom: 15px;
}

.sensorsTable__gRvQo {
  width: 100%;
  box-shadow: var(--table-box-shadow);
}

.sensorsTableHead__XmQxq {
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
}

.sensorsTableTh__t4iwK {
  font-size: 11px;
  font-weight: 400;
  line-height: 13px;
  letter-spacing: 0.05px;
  color: var(--tables-title-text);
  text-transform: uppercase;
  text-align: left;
  padding: 15px;
  background: var(--tables-title-surface);
  position: sticky;
  top: 0;
}
.sensorsTableTh__t4iwK:first-child {
  padding-left: 25px;
  cursor: pointer;
}

.sensorsTableBodyRow__qzyW2 {
  background: var(--tables-secondary-row-sub-title-surface);
}
.sensorsTableBodyRow__qzyW2:hover {
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-hover);
}

.sensorsTableTd__d1JSl {
  font-size: 14px;
  line-height: 17px;
  color: var(--tables-primary-row-text-main);
  padding: 20px 15px 19px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}
.sensorsTableTd__d1JSl:first-child {
  padding-left: 25px;
}

.link__Ac2sy {
  width: 400px;
  color: var(--buttons-surface);
  text-decoration: none;
  cursor: pointer;
}

.noSensorText__Oi4G5 {
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  color: var(--tables-primary-row-text-additional);
  text-align: left;
  text-transform: uppercase;
}

.tachometerCell__jGwsI {
  text-transform: uppercase;
  color: var(--buttons-surface);
  cursor: pointer;
}

.skeletonSensorsTableItem__pPhzm {
  height: 24px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItem/components/NodeSensors/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,qDAAA;EACA,mCAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,mCAAA;AAzEF;;AA4EA;EACE,mDAAA;EACA,uCAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,+BAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EAEA,uCAAA;EACA,gBAAA;EACA,MAAA;AA1EF;AA4EE;EACE,kBAAA;EACA,eAAA;AA1EJ;;AA8EA;EACE,yDAAA;AA3EF;AA4EE;EACE,yDAAA;EACA,mDAAA;AA1EJ;;AA8EA;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,uBAAA;EACA,yDAAA;AA3EF;AA6EE;EACE,kBAAA;AA3EJ;;AA+EA;EACE,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,eAAA;AA5EF;;AA+EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gDAAA;EACA,gBAAA;EACA,yBAAA;AA5EF;;AA+EA;EACE,yBAAA;EACA,6BAAA;EACA,eAAA;AA5EF;;AA+EA;EACE,YAAA;AA5EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.blockHead {\n  min-height: 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.blockTitle {\n  font-size: 11px;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n}\n\n.blockContainer {\n  padding: 25px;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--table-box-shadow);\n}\n\n.information {\n  font-size: 14px;\n  line-height: 17px;\n  color: var(--tables-primary-row-text-main);\n  margin-bottom: 15px;\n}\n\n.sensorsTable {\n  width: 100%;\n  box-shadow: var(--table-box-shadow);\n}\n\n.sensorsTableHead {\n  border-bottom: 1px solid var(--tables-title-stroke);\n  background: var(--tables-title-surface);\n}\n\n.sensorsTableTh {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 13px;\n  letter-spacing: 0.05px;\n  color: var(--tables-title-text);\n  text-transform: uppercase;\n  text-align: left;\n  padding: 15px;\n\n  background: var(--tables-title-surface);\n  position: sticky;\n  top: 0;\n\n  &:first-child {\n    padding-left: 25px;\n    cursor: pointer;\n  }\n}\n\n.sensorsTableBodyRow {\n  background: var(--tables-secondary-row-sub-title-surface);\n  &:hover {\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    background: var(--tables-primary-row-surface-hover);\n  }\n}\n\n.sensorsTableTd {\n  font-size: 14px;\n  line-height: 17px;\n  color: var(--tables-primary-row-text-main);\n  padding: 20px 15px 19px;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n\n  &:first-child {\n    padding-left: 25px;\n  }\n}\n\n.link {\n  width: 400px;\n  color: var(--buttons-surface);\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.noSensorText {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 12px;\n  color: var(--tables-primary-row-text-additional);\n  text-align: left;\n  text-transform: uppercase;\n}\n\n.tachometerCell {\n  text-transform: uppercase;\n  color: var(--buttons-surface);\n  cursor: pointer;\n}\n\n.skeletonSensorsTableItem {\n  height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blockHead": `blockHead__I87ge`,
	"blockTitle": `blockTitle__NTK2b`,
	"blockContainer": `blockContainer__jA6u6`,
	"information": `information__IN9gK`,
	"sensorsTable": `sensorsTable__gRvQo`,
	"sensorsTableHead": `sensorsTableHead__XmQxq`,
	"sensorsTableTh": `sensorsTableTh__t4iwK`,
	"sensorsTableBodyRow": `sensorsTableBodyRow__qzyW2`,
	"sensorsTableTd": `sensorsTableTd__d1JSl`,
	"link": `link__Ac2sy`,
	"noSensorText": `noSensorText__Oi4G5`,
	"tachometerCell": `tachometerCell__jGwsI`,
	"skeletonSensorsTableItem": `skeletonSensorsTableItem__pPhzm`
};
module.exports = ___CSS_LOADER_EXPORT___;
